import { compose, withProps } from 'recompose';
import { Redirect } from 'react-router-dom';

import withLocale from 'app/features/localization/enhancers/withLocale';
import localizeLink from 'app/features/localization/localizeLink';
import withAppName from 'app/enhancers/withAppName';
import { NEXT, REGISTER_PATH } from 'app/router/constants/paths';

const to = ({ locale, appName, next }) => ({
  to: localizeLink(
    `/${appName}${REGISTER_PATH}${next ? `?${NEXT}=${next}` : ''}`,
    locale,
  ),
});

const RegisterRedirect = compose(
  withLocale,
  withAppName,
  withProps(to),
)(Redirect);

export { to };

export default RegisterRedirect;
